import React from 'react';
import { InputHandler } from '../../easy_lib/Advanced';

export const SearchBar = ({ label, ...props }) => <InputHandler label={label} {...props} />;
